import produce from "immer";
import { findLastKey, get } from "lodash";
import PropTypes from "prop-types";
import React from "react";

// @material-ui/core components
import Checkbox from "@mui/material/Checkbox";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import { withStyles } from "@mui/styles";
import TextField from "@mui/material/TextField";

import consultationStyles from "../styles/consultationStyles.js";

import { COLOR_KICK_BLUE } from "~/shared/sharedConstants.js";

import imgDiastolic from "../../../../images/visits/diastolic-smaller.svg";
import imgSystolic from "../../../../images/visits/systolic-smaller.svg";

function RightSideColorLabel({ color, text }) {
  return (
    <div
      style={{
        color: color,
        fontSize: "14px",
        display: "flex",
        alignItems: "center",
        marginRight: "-16px",
      }}
    >
      {text}{" "}
      <div
        style={{
          backgroundColor: color,
          height: "26px",
          width: "4px",
          marginLeft: "6px",
          borderRadius: "4px",
        }}
      ></div>
    </div>
  );
}

class ConsultationQuestion extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    question: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
  }

  handleTextFieldChange = (event) => {
    const { question, questionIndex, consultAnswers, recordAnswer } =
      this.props;

    // grab answerId and code if exists in textarea id attribute - for nested checkbox answers
    var answerId, code;
    const splitIds = event.target.id.split("#");
    if (splitIds.length > 1) {
      answerId = splitIds[1];
      code = splitIds[2];
    }
    // console.log("code:", code);

    // currentAnswer = ;
    const answer = produce(consultAnswers[questionIndex] || {}, (draft) => {
      if (answerId == null) {
        draft.question = question;
        draft.type = "text";
        draft.value = event.target.value;
        draft.title = event.target.name;
        draft.code = event.target.code;
      } else {
        // textfield is a child
        const textResponse = {
          type: "textarea",
          value: event.target.value,
          title: event.target.name,
        };
        draft[answerId] = consultAnswers[questionIndex][answerId] || {};
        draft[answerId].childAnswers = draft[answerId].childAnswers || {};
        draft[answerId].childAnswers[code] = textResponse;
      }
    });

    recordAnswer(questionIndex, answer);
  };

  isCheckboxSelected = (answerIndex) => {
    const { questionIndex, consultAnswers } = this.props;
    return !!consultAnswers[questionIndex]?.[answerIndex]?.checked;
  };
  isRadioSelected = (questionIndex, answerIndex) => {
    const { consultAnswers } = this.props;
    return !!(consultAnswers[questionIndex]?.selectedIndex == answerIndex);
  };
  isChildRadioSelected = (questionIndex, answerIndex, code, label) => {
    const { consultAnswers } = this.props;

    return !!(
      consultAnswers[questionIndex]?.[answerIndex]?.childAnswers?.[code]
        ?.selectedValue == label
    );
  };
  shouldShowChild = (question, questionIndex, answerIndex) => {
    switch (question.type) {
      case "checkbox":
        return this.isCheckboxSelected(answerIndex);
      case "radio":
        return this.isRadioSelected(questionIndex, answerIndex);
    }
  };
  handleCheckboxChange = (event) => {
    const { question, questionIndex, consultAnswers, recordAnswer } =
      this.props;

    if (event.target.name.toLowerCase() == "none of the above") {
      recordAnswer(questionIndex, {
        question: question,
        [event.target.value]: {
          title: event.target.name,
          checked: event.target.checked,
          silent: true,
        },
      });
    } else {
      const answer = produce(consultAnswers[questionIndex] || {}, (draft) => {
        draft.question = question;
        // draft.type = "checkbox";
        draft[event.target.value] = {
          title: event.target.name,
          checked: event.target.checked,
        };

        // if (consultAnswers[consultAnswers.length-1].
        // turn off "none of the above"
        const notaKey = findLastKey(consultAnswers[questionIndex], {
          title: "None of the above",
        });
        delete draft[notaKey];
      });

      recordAnswer(questionIndex, answer);
    }
  };

  renderTextArea = () => {
    const { classes, question, questionIndex, questionError, consultAnswers } =
      this.props;

    return (
      <div
        style={{
          backgroundColor: "#FFFFFF",
          borderRadius: "4px",
          padding: "2px 0 2px",
        }}
      >
        <TextField
          fullWidth={true}
          id={questionIndex.toString()}
          label=""
          multiline
          error={questionError != ""}
          minRows="6"
          maxRows="10"
          className={classes.textField}
          variant="outlined"
          onChange={this.handleTextFieldChange}
          value={get(consultAnswers, [questionIndex, "value"]) || ""}
          style={{
            width: "98%",
            margin: "4px auto 4px auto",
            display: "block",
          }}
        />
      </div>
    );
  };

  renderText = () => {
    const { classes, question, questionIndex, questionError, consultAnswers } =
      this.props;

    return (
      <div
        style={{
          backgroundColor: "#FFFFFF",
          borderRadius: "4px",
          padding: "2px 0 2px",
        }}
      >
        <TextField
          fullWidth={true}
          id={questionIndex.toString()}
          label=""
          error={questionError != ""}
          className={classes.textField}
          variant="outlined"
          onChange={this.handleTextFieldChange}
          value={get(consultAnswers, [questionIndex, "value"]) || ""}
          style={{
            width: "98%",
            margin: "4px auto 4px auto",
            display: "block",
          }}
        />
      </div>
    );
  };

  handleRadioChange = (event) => {
    const { question, questionIndex, consultAnswers, recordAnswer } =
      this.props;

    // currentAnswer = ;
    const answer = produce(consultAnswers[questionIndex] || {}, (draft) => {
      draft.question = question;
      draft.selected = event.target.name;
      draft.selectedIndex = event.target.value;
      delete draft.textResponse;
    });

    recordAnswer(questionIndex, answer);
  };

  handleChildRadioChange = (answerIndex, code) => (event) => {
    const { question, questionIndex, consultAnswers, recordAnswer } =
      this.props;

    const answer = produce(consultAnswers[questionIndex] || {}, (draft) => {
      draft[answerIndex] = draft[answerIndex] || {};
      draft[answerIndex].childAnswers = draft[answerIndex].childAnswers || {};
      draft[answerIndex].childAnswers[code] =
        draft[answerIndex].childAnswers[code] || {};
      draft[answerIndex].childAnswers[code].selectedIndex = event.target.value;
      draft[answerIndex].childAnswers[code].selectedValue = event.target.name;
    });
    recordAnswer(questionIndex, answer);
  };

  renderRadioGroup = (choices, isChildRadio, code, answerIndex) => {
    const { classes, question, questionIndex, questionError } = this.props;
    let radioGroup = choices.map((choice, i) => {
      return (
        <div key={`${code}-${i}`}>
          <FormControl
            component="fieldset"
            className={classes.formControl}
            required
            error={questionError != ""}
            style={{
              width: "100%",
              display: "flex",
            }}
          >
            <RadioGroup
              aria-label="RadioGroup"
              name="RadioGroup"
              className={classes.group}
              onChange={
                isChildRadio
                  ? this.handleChildRadioChange(answerIndex, code)
                  : this.handleRadioChange
              }
              style={{
                margin: "0 20px 0 20px",
                flexDirection: "row",
              }}
            >
              <FormControlLabel
                style={{ width: "100%" }}
                control={
                  <div style={{ display: "flex", width: "100%" }}>
                    <Radio
                      checked={
                        isChildRadio
                          ? this.isChildRadioSelected(
                              questionIndex,
                              answerIndex,
                              code,
                              choice.label,
                            )
                          : this.isRadioSelected(questionIndex, i)
                      }
                      value={i}
                      data-code={code}
                      name={choice.label}
                      aria-label={i}
                      classes={{
                        checked: classes.radio,
                      }}
                    />
                    <div
                      className={this.props.classes.radioLabel}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        flex: 1,
                        justifyContent: "space-between",
                      }}
                    >
                      {choice.label}
                      {choice.rightSideColorLabel && (
                        <RightSideColorLabel
                          text={choice.rightSideColorLabel.text}
                          color={choice.rightSideColorLabel.color}
                        />
                      )}
                    </div>
                  </div>
                }
              />
            </RadioGroup>
          </FormControl>
          {isChildRadio
            ? this.renderGrandchildren(choice, i, answerIndex, code)
            : this.renderQuestionChildren(choice, i)}
        </div>
      );
    });

    return (
      <div
        style={{
          padding: "10px 0 10px 0",
          borderRadius: "4px",
          marginTop: "10px",
          backgroundColor: "#FFFFFF",
        }}
      >
        {radioGroup}
      </div>
    );
  };

  renderChild = (child, answerIndex) => {
    const { classes, question, questionIndex, consultAnswers } = this.props;

    if (child.code == null || child.code == "") {
      console.error("Missing code on consultation question child");
    }

    if (this.shouldShowChild(this.props.question, questionIndex, answerIndex)) {
      switch (child.type) {
        case "radio":
          return (
            <div
              key={`${questionIndex}#${child.code}#${answerIndex}`}
              style={{ marginLeft: "22px" }}
            >
              <h4>{child.title}</h4>
              {this.renderRadioGroup(
                child.choices,
                true,
                child.code || "",
                answerIndex,
              )}
            </div>
          );
        case "text":
        case "textarea":
          // get from state
          const textValue =
            get(consultAnswers, [
              questionIndex,
              answerIndex,
              "childAnswers",
              child.code,
              "value",
            ]) || "";

          return (
            <TextField
              fullWidth={true}
              name={child.code}
              id={`${questionIndex}#${answerIndex}#${child.code}`}
              key={`${questionIndex}#${answerIndex}#${child.code}`}
              label={child.title}
              InputLabelProps={{
                style: {
                  textOverflow: "wrap",
                  // whiteSpace: "nowrap",
                  // overflow: "hidden",
                  width: "95%",
                  lineHeight: "1.2",
                  // color: "green"
                },
              }}
              multiline={child.type == "textarea"}
              minRows="4"
              maxRows="8"
              className={classes.textField}
              variant="outlined"
              value={textValue}
              onChange={this.handleTextFieldChange}
              style={{
                width: "96%",
                margin: "10px auto 20px auto",
                display: "block",
                // border: "3px solid pink"
              }}
            />
          );
      }
    }
  };
  renderQuestionChildren = (choice, answerIndex) => {
    if (choice.children) {
      const childElements = choice.children.map((child) => {
        return this.renderChild(child, answerIndex);
      });

      return childElements;
    }
  };

  renderGrandchildren = (
    choice,
    choiceIndex,
    parentAnswerIndex,
    parentCode,
  ) => {
    const { questionIndex } = this.props;

    if (choice.children) {
      // Check if this child radio choice is selected
      const isSelected = this.isChildRadioSelected(
        questionIndex,
        parentAnswerIndex,
        parentCode,
        choice.label,
      );

      if (isSelected) {
        return choice.children.map((grandchild) => {
          return this.renderGrandchild(
            grandchild,
            parentAnswerIndex,
            parentCode,
            choiceIndex,
          );
        });
      }
    }
  };

  renderGrandchild = (
    grandchild,
    parentAnswerIndex,
    parentCode,
    choiceIndex,
  ) => {
    const { classes, questionIndex, consultAnswers } = this.props;

    if (grandchild.code == null || grandchild.code == "") {
      console.error("Missing code on consultation question grandchild");
    }

    switch (grandchild.type) {
      case "text":
      case "textarea": {
        // Get grandchild answer from state
        const textValue =
          get(consultAnswers, [
            questionIndex,
            parentAnswerIndex,
            "childAnswers",
            parentCode,
            choiceIndex,
            "childAnswers",
            grandchild.code,
            "value",
          ]) || "";

        return (
          <TextField
            fullWidth={true}
            name={grandchild.code}
            id={`${questionIndex}#${parentAnswerIndex}#${parentCode}#${choiceIndex}#${grandchild.code}`}
            key={`${questionIndex}#${parentAnswerIndex}#${parentCode}#${choiceIndex}#${grandchild.code}`}
            label={grandchild.title}
            InputLabelProps={{
              style: {
                textOverflow: "wrap",
                width: "95%",
                lineHeight: "1.2",
              },
            }}
            multiline={grandchild.type == "textarea"}
            minRows="4"
            maxRows="8"
            className={classes.textField}
            variant="outlined"
            value={textValue}
            onChange={this.handleGrandchildTextFieldChange(
              parentAnswerIndex,
              parentCode,
              choiceIndex,
            )}
            style={{
              width: "90%",
              margin: "10px auto 20px auto",
              display: "block",
            }}
          />
        );
      }
    }
  };

  handleGrandchildTextFieldChange =
    (parentAnswerIndex, parentCode, choiceIndex) => (event) => {
      const { question, questionIndex, consultAnswers, recordAnswer } =
        this.props;

      const grandchildCode = event.target.name;

      const answer = produce(consultAnswers[questionIndex] || {}, (draft) => {
        draft[parentAnswerIndex] = draft[parentAnswerIndex] || {};
        draft[parentAnswerIndex].childAnswers =
          draft[parentAnswerIndex].childAnswers || {};
        draft[parentAnswerIndex].childAnswers[parentCode] =
          draft[parentAnswerIndex].childAnswers[parentCode] || {};
        draft[parentAnswerIndex].childAnswers[parentCode][choiceIndex] =
          draft[parentAnswerIndex].childAnswers[parentCode][choiceIndex] || {};
        draft[parentAnswerIndex].childAnswers[parentCode][
          choiceIndex
        ].childAnswers =
          draft[parentAnswerIndex].childAnswers[parentCode][choiceIndex]
            .childAnswers || {};
        draft[parentAnswerIndex].childAnswers[parentCode][
          choiceIndex
        ].childAnswers[grandchildCode] = {
          type: "textarea",
          value: event.target.value,
          title: event.target.name,
        };
      });

      recordAnswer(questionIndex, answer);
    };

  renderCheckboxes = (choices) => {
    const { classes, questionError } = this.props;

    let checkboxes = choices.map((choice, i) => {
      return (
        <div
          key={i}
          style={{
            backgroundColor: "#FFFFFF",
            padding: "14px 0 14px 0",
            margin: "0 20px 0 20px",
            borderBottom:
              i === choices.length - 1 ? "" : `1px solid ${COLOR_KICK_BLUE}`,
            borderTop:
              i === choices.length - 1 &&
              choices[choices.length - 1].label.toLowerCase() ==
                "none of the above"
                ? `1px solid ${COLOR_KICK_BLUE}`
                : "",
            marginTop:
              i === choices.length - 1 &&
              choices[choices.length - 1].label.toLowerCase() ==
                "none of the above"
                ? "2px"
                : "0",
          }}
        >
          <FormControl required error={questionError != ""}>
            <FormControlLabel
              control={
                <Checkbox
                  value={i.toString()}
                  tabIndex={i}
                  onClick={this.handleCheckboxChange}
                  name={choice.label}
                  aria-label={i.toString()}
                  checked={this.isCheckboxSelected(i)}
                  disabled={choice.disabled}
                />
              }
              classes={{
                root: classes.checkboxLabelControl,
                label: classes.checkboxLabel,
              }}
              label={<div dangerouslySetInnerHTML={{ __html: choice.label }} />}
            />
          </FormControl>
          {this.renderQuestionChildren(choice, i)}
        </div>
      );
    });
    return (
      <div
        style={{
          padding: "10px 0 10px 0",
          borderRadius: "4px",
          marginTop: "10px",
          backgroundColor: "#FFFFFF",
        }}
      >
        {checkboxes}
      </div>
    );
  };

  renderQuestion = (question) => {
    switch (question.type) {
      case "bloodpressure-systolic":
      case "bloodpressure-diastolic":
        return (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              backgroundColor: "#FFFFFF",
            }}
          >
            <img
              src={
                question.type == "bloodpressure-diastolic"
                  ? imgDiastolic
                  : imgSystolic
              }
              style={{
                height: "150px",
                margin: "24px auto 0",
                paddingBottom: "30px",
                borderBottom: `2px solid ${COLOR_KICK_BLUE}`,
              }}
              alt="systolic blood pressure"
            />
            {this.renderRadioGroup(question.choices, false)}
          </div>
        );

      case "checkbox":
        return this.renderCheckboxes(question.choices);

      case "radio":
        return this.renderRadioGroup(question.choices, false);

      case "text":
        return this.renderText();

      case "textarea":
        return this.renderTextArea();
    }
  };

  render() {
    const { classes, question } = this.props;
    if (!question) {
      return null;
    }
    return (
      <form className={classes.form} onSubmit={() => event.preventDefault()}>
        <h3
          style={{
            color: "#FFFFFF",
            fontFamily: "Spectral-SemiBold",
            fontSize: "32px",
          }}
        >
          {question.title}
        </h3>
        <p
          style={{
            color: "#FFFFFF",
            fontFamily: "BasisGrotesquePro-Regular",
            fontSize: "18px",
            lineHeight: "26px",
            // letterSpacing: "-0.21px"
          }}
        >
          {question.description}
        </p>
        <div
          style={{ display: "flex", flexDirection: "column" }}
          className={classes.checkboxAndRadio}
        >
          {this.renderQuestion(question)}
        </div>
      </form>
    );
  }
}

export default withStyles(consultationStyles)(ConsultationQuestion);
